import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Button } from '../components/Button';

export function Home() {
  const { actor } = useAuth();
  return (
    <div className="container stack">
      <div className="card stack" style={{ textAlign: 'center' }}>
        <h1>My Golf Event</h1>
        <p className="muted">Score, share, and play your tournament — on your phone.</p>
      </div>

      <div className="stack">
        {actor?.kind === 'user' ? (
          <>
            <Link to="/events/new"><Button block>Create event</Button></Link>
            <Link to="/events"><Button block variant="secondary">View my events</Button></Link>
            <Link to="/join"><Button block variant="secondary">Join an event by code</Button></Link>
          </>
        ) : (
          <>
            <Link to="/join"><Button block>Join an event by code</Button></Link>
            <Link to="/signin"><Button block variant="secondary">Sign in</Button></Link>
            <Link to="/signup"><Button block variant="secondary">Create account</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
